import FormulaColumnValidator from "./FormulaColumnValidator";
import LookupColumnValidator from "./LookupColumnValidator";
import DropDownColumnValidator from "./DropDownColumnValidator";
import CodeSnippetColumnValidator from "./CodeSnippetColumnValidator";
import SubsheetColumnValidator from "./SubsheetColumnValidator";

export default function ColumnValidatorFactory(columnTypeId) {
  return getComponent(columnTypeId);
}

function getComponent(columnTypeId) {
  const defaultFunc = () => true;

  switch (parseInt(columnTypeId)) {
    case 3:
    case 13:
    case 11:
      return DropDownColumnValidator;
    case 7:
      return CodeSnippetColumnValidator;
    case 19:
      return FormulaColumnValidator;
    case 10:
      return LookupColumnValidator;
    case 6:
      return SubsheetColumnValidator;
    case 8:
    case 1:
    case 24:
    case 20:
    case 14:
    case 5:
    case 22:
    case 17:
    case 4:
    case 16:
    case 9:
    default:
      return defaultFunc;
  }
}
